module.exports = __webpack_public_path__ + "static/media/el-cargador-de-sal-min.a421ed22.png";